module.exports = __webpack_public_path__ + "static/fleet-33-seat-coach-sm-b1ee4ea631b617cf6e10693a00fa0139.webp";